export default {
    type: "row",
    style: "",
    data: {
      applyBackgroundTo: "row",
      applyImageTo: "row",
      stackOnMobile: "off",
    },
    children: [
      {
        type: "col",
        style: "",
        className: "rip-mm-col rip-mm-col-md-3",
        children: [],
      },
      {
        type: "col",
        style: {},
        className: "rip-mm-col rip-mm-col-md-9",
        children: [],
      },
    ],
  };
  